import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {VehicleService} from 'services/calculator-items/vehicle.service';
import {EmissionService} from 'services/emission.service';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {SpinnerService} from 'services/spinner.service';
import { NetworkService } from 'services/network.service';
import { UrlConfig } from 'config/urlConfig';

@Component({
    selector: 'tpc-ecar',
    templateUrl: './ecar.component.html',
    styleUrls: ['./ecar.component.css']
})
export class EcarComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmitted = false;
    public isZipValid = true;
    public ecarForm: FormGroup;
    public ecarYearList = [];
    public countryList = [];
    public stateList = [];
    public isShown:boolean = true;
    public zipShown:boolean = true;

    constructor(private emissionService: EmissionService,
                private vehicleService: VehicleService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService,
                private networkService: NetworkService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmitted = true;
            this.isZipValid = true;
            if (this.ecarForm.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
        this.ecarYearList = this.getYearList(2011);
        this.getCountryList();
    }

    private createForm() {
        this.ecarForm = this.fb.group({
            country: ['',  [
                Validators.required,
                Validators.minLength(1),
                Validators.maxLength(50),
                Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)]],
            ecarZip: ['', [
                Validators.minLength(3),
                Validators.maxLength(13),
                Validators.pattern(/^[A-Za-z0-9\-\s]+$/i)]],
            ecarYear: ['', Validators.required ],
            ecarMileage: ['', Validators.required ],
            state: ['', this.stateValidator],
        });
    }

    private stateValidator = [
        Validators.minLength(1),
        Validators.maxLength(50),
        Validators.pattern(/^[A-Za-z0-9,.\-\s]+$/i)
    ];

    private getFV(param) {
        return this.ecarForm.get(param).value;
    }

    private getYearList(start) {
        return Array.from({length: new Date().getFullYear() - start + 1}, (v, k) => k + start).reverse();
    }

    private next() {
        let zip = (this.ecarForm.get('ecarZip').value.length > 0)? this.ecarForm.get('ecarZip').value : '0000';
        let countryId = this.ecarForm.get('country').value;
        let subRegion = (this.ecarForm.get('state').value.length > 0)? this.ecarForm.get('state').value : 'N/A';

        let params = {
            CARTYPE: 'car',
            VEHICLETYPE: 'ecar',
            MILE: this.getFV('ecarMileage'),
            YEAR: this.getFV('ecarYear'),
            ZIP: zip,
            CountryID: countryId,
            SubRegion: subRegion
        };

        this.spinner.show();
        this.emissionService.getEmissionValue(params).subscribe(
            response => {
                let input = response.body[0].input[0];
                if (input.error) {
                    this.isZipValid = false;
                    this.spinner.hide();
                    return;
                }
                this.vehicleService.addToVehicleList({
                    title: this.getTitleForVehicleList(),
                    emission: input.emmission,
                    emissionTrees: input.emissionTrees,
                    DollarAmt: input.DollarAmt,
                    DollarAmtMonthly: input.DollarAmtMonthly
                });

                this.router.navigate(['/individual/vehicle/list']);
                this.spinner.hide();
            }
        );
    }

    private getTitleForVehicleList() {
        return `${this.getFV('ecarYear')} Electric Car, ${this.getFV('ecarMileage').toLocaleString()} mi/yr`;
    }

    checkError(param) {
        return this.ecarForm.get(param).status === 'INVALID' && (this.isFormSubmitted || this.ecarForm.get(param).touched);
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

    private getCountryList(): void {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), { }).subscribe(
        country => {
                this.countryList = country;
                this.spinner.hide();
            }
        );
    }

    public getStateList(state) {
        this.spinner.show();
        this.networkService.post(UrlConfig.getUrl('getStateAndCountry'), {Country: 'US', CountryID: state}).subscribe(
            states => {
                this.stateList = states.sort((a, b) => a.StateAB.localeCompare(b.StateAB));
                if(this.stateList.length > 0)
                {
                    if(this.stateList.length > 50)
                        this.zipShown = true;
                    else
                        this.zipShown = false;

                    //this.form.get('state').setValidators(this.stateValidator.concat(Validators.required));
                    this.isShown = true;
                    if(this.stateValidator.length == 3)
                        this.stateValidator = this.stateValidator.concat([Validators.required]);
                    this.ecarForm.updateValueAndValidity();
                    //this.form.get('zip').setValidators([Validators.required]);
                }
                else
                {
                    this.isShown = false;
                    this.zipShown = false;
                    if(this.stateValidator.length == 4)
                        this.stateValidator.splice(this.stateValidator.length - 1,this.stateValidator.length);
                    this.ecarForm.get('state').setValidators(this.stateValidator);
                }
                this.spinner.hide();
            }
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/shared/main/vehicle/ecar/ecar.component.ts